import ImageOptimize from '@/components/ImageOptimize'
import ProductCard from '@/components/ProductCard'
import { useNotification } from '@/containers'
import { useFlashSale } from '@/containers/FlashSaleContainer'
import { Meta } from '@/layouts/Meta'
import { Main } from '@/templates/Main'
import { type Product } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import {
  getBannerSSR,
  getBottomMenu,
  getConfigSSR,
  getFlashSaleSSR,
  getKeyword,
  getMenus,
  getQuickMenu,
  getSaleRegion,
} from '@/utils/endpoint'
import { getCookies } from 'cookies-next'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useRouter } from 'next/router'
import type { GetServerSideProps, GetServerSidePropsContext } from 'next/types'

const FlashSalePage = () => {
  const { flashSale } = useFlashSale()
  const t = useTranslations('Common')
  const router = useRouter()
  const { systemConfig } = useNotification()
  const qtt =
    systemConfig?.imageQlt && systemConfig?.imageQlt != ''
      ? systemConfig?.imageQlt
      : 80
  const customStyle = {
    backgroundColor: flashSale?.customization?.backgroundColor,
    backgroundImage:
      flashSale?.customization?.backgroundImage &&
      `url(${flashSale?.customization?.backgroundImage}?format=webp&quality=${qtt})`,
    backgroundRepeat: flashSale?.customization?.backgroundImage && 'no-repeat',
    backgroundPosition:
      flashSale?.customization?.backgroundImage && 'top center',
    backgroundSize: flashSale?.customization?.backgroundImage && '100% auto',
  }
  return (
    <Main
      meta={
        <Meta
          title={
            getTranslate(flashSale?.metaTitle) &&
            getTranslate(flashSale?.metaTitle) !== ''
              ? getTranslate(flashSale?.metaTitle)
              : getTranslate(flashSale?.name)
          }
          description={
            getTranslate(flashSale?.metaDescription) &&
            getTranslate(flashSale?.metaDescription) !== ''
              ? getTranslate(flashSale?.metaDescription)
              : getTranslate(flashSale?.content)
          }
          noFollow={flashSale?.noFollow}
          noIndex={flashSale?.noIndex}
          canonical={
            flashSale?.canonicalUrl ||
            process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath
          }
          mobileAlternate={{
            media: 'only screen and (max-width:991px))',
            href:
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
              process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
              '',
          }}
        />
      }
      style={customStyle}
    >
      <section className='flash-sale wrapper'>
        {flashSale ? (
          <>
            {flashSale?.customization?.banner ? (
              <>
                {flashSale?.customization?.bannerLink ? (
                  <div className='banner mb-4 block w-full overflow-hidden rounded-sm'>
                    <Link href={flashSale?.customization?.bannerLink}>
                      <ImageOptimize
                        src={flashSale?.customization?.banner}
                        alt={getTranslate(flashSale.name)}
                        priority={true}
                        className='h-auto w-full'
                      />
                    </Link>
                  </div>
                ) : (
                  <div className='banner mb-4 block w-full overflow-hidden rounded-sm'>
                    <ImageOptimize
                      src={flashSale?.customization?.banner}
                      alt={getTranslate(flashSale?.name)}
                      priority={true}
                      className='h-auto w-full'
                    />
                  </div>
                )}
              </>
            ) : (
              <></>
            )}

            <div className='listProduct grid grid-cols-4 gap-4 pb-[80px]'>
              {flashSale &&
                flashSale.products.map((item: Product) => {
                  return (
                    <ProductCard
                      product={item}
                      type='flashSale'
                      layout={4}
                      className='rounded-[6px]'
                      descClassName={`${
                        flashSale?.backgroundColor && 'px-[12px]'
                      } pb-3`}
                      key={item._id}
                    />
                  )
                })}
            </div>
          </>
        ) : (
          <>
            <div className='mb-[120px]  mt-[44px] flex flex-col items-center justify-center'>
              <ImageOptimize
                quality={100}
                src='/no-product.svg'
                alt='Không tìm thấy sản phẩm phù hợp'
                width={500}
                height={372}
              />
              <span className='mt-[20px] text-HeadlineMedium font-normal'>
                Không tìm thấy sản phẩm phù hợp
                {t('notFoundProductFit')}
              </span>
            </div>
          </>
        )}
      </section>
    </Main>
  )
}

export default FlashSalePage

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res, query } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )
  const params: string = query?.viewAt ? (query?.viewAt as string) : ''

  const [
    menus,
    flashSale,
    quickMenu,
    banner,
    bottomMenu,
    systemConfig,
    regions,
    keywords,
  ] = await Promise.all([
    getMenus(),
    getFlashSaleSSR(params),
    getQuickMenu(),
    getBannerSSR(),
    getBottomMenu(),
    getConfigSSR(),
    getSaleRegion(),
    getKeyword(),
  ])

  return {
    props: {
      messages,
      menus,
      quickMenu,
      flashSale,
      banner,
      language,
      systemConfig,
      bottomMenu,
      regions,
      keywords,
      token: token || null,
    },
  }
}
